 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		25: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~e20a97ce","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","7":"source~bet-details-page~betting-history-page","8":"source~i18n-widgets-ar-json","9":"source~i18n-widgets-az-json","10":"source~i18n-widgets-de-json","11":"source~i18n-widgets-en-ca-json","12":"source~i18n-widgets-en-in-json","13":"source~i18n-widgets-en-json","14":"source~i18n-widgets-es-cl-json","15":"source~i18n-widgets-es-json","16":"source~i18n-widgets-es-pe-json","17":"source~i18n-widgets-fa-json","18":"source~i18n-widgets-fi-json","19":"source~i18n-widgets-lv-json","20":"source~i18n-widgets-no-json","21":"source~i18n-widgets-ru-json","22":"source~i18n-widgets-tr-json","23":"source~i18n-widgets-zh-cn-json","26":"source~/esports-betting-rules-TR","27":"source~bet-builder-rules-DE","28":"source~bet-builder-rules-EN","29":"source~bet-builder-rules-ES","30":"source~bet-builder-rules-ES-MX","31":"source~bet-builder-rules-ET","32":"source~bet-builder-rules-FI","33":"source~bet-builder-rules-FR","34":"source~bet-builder-rules-IT","35":"source~bet-builder-rules-JA","36":"source~bet-builder-rules-KA","37":"source~bet-builder-rules-LT","38":"source~bet-builder-rules-LV","39":"source~bet-builder-rules-PL","40":"source~bet-builder-rules-PT-BR","41":"source~bet-builder-rules-RO","42":"source~bet-builder-rules-RU","43":"source~bet-builder-rules-SQ","44":"source~bet-builder-rules-TR","45":"source~bet-details-page","46":"source~betting-history-container","47":"source~betting-history-page","48":"source~betting-rules-DA","49":"source~betting-rules-DE","50":"source~betting-rules-EN","51":"source~betting-rules-ES","52":"source~betting-rules-ES-MX","53":"source~betting-rules-FR","54":"source~betting-rules-IT","55":"source~betting-rules-JA","56":"source~betting-rules-PL","57":"source~betting-rules-PT","58":"source~betting-rules-PT-BR","59":"source~betting-rules-RO","60":"source~betting-rules-RU","61":"source~betting-rules-SQ","62":"source~betting-rules-TR","63":"source~bonus-info","64":"source~cashout-terms-AR","65":"source~cashout-terms-DA","66":"source~cashout-terms-DE","67":"source~cashout-terms-EN","68":"source~cashout-terms-ES","69":"source~cashout-terms-ES-MX","70":"source~cashout-terms-ET","71":"source~cashout-terms-FI","72":"source~cashout-terms-FR","73":"source~cashout-terms-IT","74":"source~cashout-terms-JA","75":"source~cashout-terms-KA","76":"source~cashout-terms-KU","77":"source~cashout-terms-LT","78":"source~cashout-terms-LV","79":"source~cashout-terms-PL","80":"source~cashout-terms-PT","81":"source~cashout-terms-PT-BR","82":"source~cashout-terms-RO","83":"source~cashout-terms-RU","84":"source~cashout-terms-SQ","85":"source~cashout-terms-SR","86":"source~cashout-terms-TR","87":"source~esports-betting-rules-DA","88":"source~esports-betting-rules-DE","89":"source~esports-betting-rules-EN","90":"source~esports-betting-rules-ES","91":"source~esports-betting-rules-ES-MX","92":"source~esports-betting-rules-ET","93":"source~esports-betting-rules-FI","94":"source~esports-betting-rules-FR","95":"source~esports-betting-rules-IT","96":"source~esports-betting-rules-JA","97":"source~esports-betting-rules-KA","98":"source~esports-betting-rules-LT","99":"source~esports-betting-rules-LV","100":"source~esports-betting-rules-PL","101":"source~esports-betting-rules-PT","102":"source~esports-betting-rules-PT-BR","103":"source~esports-betting-rules-RO","104":"source~esports-betting-rules-RU","105":"source~esports-betting-rules-SQ","106":"source~esports-betting-rules-SR","107":"source~generated-mappings","108":"source~i18n-ar-json","109":"source~i18n-az-json","110":"source~i18n-de-json","111":"source~i18n-en-json","112":"source~i18n-es-cl-json","113":"source~i18n-es-json","114":"source~i18n-es-pe-json","115":"source~i18n-fa-json","116":"source~i18n-fi-json","117":"source~i18n-lv-json","118":"source~i18n-no-json","119":"source~i18n-ru-json","120":"source~i18n-tr-json","121":"source~i18n-zh-cn-json","123":"source~settings-page","124":"source~streaming-carousel","125":"source~virtual-esports-betting-rules-EN","126":"source~virtual-esports-betting-rules-IT","127":"source~virtual-esports-betting-rules-JA","128":"source~virtual-esports-betting-rules-PL","130":"vendors~rc-slider","131":"vendors~react-google-recaptcha","132":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"a788bbd23a9139670c4b","1":"3a9991e5d939a87c3c4c","2":"2ec0ebe4210f1f795b51","3":"de9ebc35c2e1d704babe","4":"ea5a6c0f6c2b389e9bf2","5":"e86d1b391941002558e6","6":"9f667fd1134167259e7b","7":"344bafb5853901e4dccb","8":"27383448772044af2c28","9":"d7793d7ad6ccce67fa6f","10":"4f53fe87ec34d99be288","11":"8088a58ccb9963717003","12":"7874f9d6b509622899db","13":"5b3856786cebaa18c3bc","14":"7cae0d45c63566ceed5d","15":"6c25efc1741505b3dce9","16":"35ad80661635fa321c3c","17":"4cce6ce52148934ede94","18":"f5e6846a46675c261efe","19":"118676453ba2aff30567","20":"e3cdb701e19b241db71e","21":"f10a396146715b86e6d4","22":"db3dfc11eb625c9316b7","23":"154e404b67c65a2a05fd","26":"13b564c503372f2064e0","27":"186857df6b5b3a2b78ed","28":"158d9e1f8fed9a98efa6","29":"d1d57b9a949a7b36536d","30":"d4ac3baa5e461b00f9b8","31":"ef23a12fb35657947b50","32":"0898ec2eaa6c426c80eb","33":"5978849c631aadc399c5","34":"b9eb96de05f524bfafa4","35":"37bb8350e8b069b1b047","36":"ea17cb18dd3e0bd4b659","37":"23217fb75c1daf0e1253","38":"2c780a7fe0446d999e69","39":"b53b030a93de7a165f4f","40":"de9ac79dae15611bd3b5","41":"a0f6902cdafe119db96a","42":"35dd0c506e776cdbd381","43":"8671b3186f7ae0a28ac7","44":"1cd23a889c0a09b2b3fd","45":"738e2d32577e09f7924b","46":"1f1cbc668db0db49488a","47":"f727beef09cde96556ce","48":"e3244a643bb537634978","49":"382b74b62d5a7e4ca362","50":"e7943719581ac4114818","51":"51d51356c0007662c4a9","52":"e8653e033aca69cf0bcd","53":"bee2ca3308018a6434e0","54":"036fbcd7640c3187fdca","55":"4bf6e09ad7db68adb3ca","56":"18d2226e112d2759b874","57":"4a48fd035c8950ac16f0","58":"1aca2ade45e6750a0523","59":"a56d86c906045015f912","60":"d2827c4194b0c13048b9","61":"75442d4c185142451134","62":"4fd69e3e5cfa61eade80","63":"6f622ae830b618cc2587","64":"50aa623fb575c9b55d14","65":"d8c59de34fc3534fb4da","66":"55a8024e228f29fd6f62","67":"3d114c4e6d1c1cb431ed","68":"9849ddcd905370206b11","69":"026b96c0bbc0b8dcbeae","70":"2ea165d5f5dfd073c205","71":"4d7c8c6e7bbb695394d7","72":"8ca126b01e141bffaf34","73":"169bac7445321d96c64f","74":"34cad531cb2da696fdb1","75":"35fb0da7cf81c9165daa","76":"698fee2fc9315c52f930","77":"9d32987a762bec09ba19","78":"aebe761ad565057a65fd","79":"0afb2a7fff98625838d7","80":"746d482cb43fd47476ee","81":"256bac3d23febb9c4e74","82":"ed45f04ae03b7b76af39","83":"7051506f2c6e9713d068","84":"0fce22ebd4b72e7087e7","85":"845831ac8a11ab7da27d","86":"277c1a0027cc635bb697","87":"fd52dba51e0567875efa","88":"a857c717319d4721ea42","89":"8da78524c73f259e90af","90":"857f695090d82923782e","91":"ae473c8aaad833b073bc","92":"cd45a4b45c9ee11ea444","93":"e5e2cfc6309f3657364f","94":"dba37c14b5b1261a9210","95":"1dd3c2ebb15a573b3f94","96":"0f8af403ad2639279104","97":"1391519441b9db6a6cfa","98":"b829e7852ccdc9c73d1d","99":"be69eee6d7d91cfe3cd0","100":"d83805d2f33db650aa99","101":"6ffc54988e394fc989a6","102":"5008bb6fce65c91a4929","103":"77294a8fc3cb81d1c762","104":"e453f23607222e82382f","105":"c21634dcb49bd4414f74","106":"f76c8e954cfb0737d6c5","107":"66da4436879c427a328d","108":"48f30ba16b96fa5c15e1","109":"3597785e7fdbc3d3a265","110":"769a56113420147c9277","111":"3210863797b5a7eb1b5e","112":"a2933841f2290ca03c1b","113":"bee20fb208ef26bea844","114":"928087a6879d1621db32","115":"4845efebddded4403d3c","116":"69821d6a8b3b4cd51fbe","117":"bdb117dabb2485e52218","118":"bf296bb21e16d9eb72fe","119":"91ab1e3c36dcadb3ff09","120":"ad672e5bc59acb0b54cd","121":"8e15318a98a92050add3","123":"a1ba4caf777ab78efb5f","124":"75bcc0b85163bd7dc86f","125":"38e77524a505fc0f2c3d","126":"f86b27130471880ce826","127":"b2960c6acd5a868e1328","128":"5c7b8ba0f626c7867504","130":"eded3a99890de76aaa91","131":"17d88e260c123c9237aa","132":"d40b0b5b755d3f8d5475","133":"f2901314e2525bca357a","134":"90e5ac5f6ecd4cc7716b","135":"8efffaf5264a5e31fc9e","136":"92f53c16fcc807014e44","137":"1755a1fc40a9bec22381","138":"83b7f9c3d03364d4c21c","139":"fd886c4ce2e356902b11","140":"eab2b6fb5207c6eba05a","141":"9d8b7029bc73e51a0f39","142":"67e613720a57e9cc6504","143":"5095347b5f07cf2dc143","144":"40119744c6d59b30b9ad","145":"1bb8b900e24050cc370e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
